"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RbcPlacement = void 0;
exports.RbcPlacement = {
    None: 'none',
    Forced: 'forced',
    Promo: 'promo',
    Dialog: 'dialog',
    Dashboard: 'dashboard',
    CarePlan: 'care_plan',
    CarePlanDialog: 'care_plan_dialog',
    CarePlanMiddleScreen: 'care_plan_middle_screen',
    ScreeningResult: 'screening_result',
    ScreeningResultLowerScreen: 'screening_result_lower_screen',
    Resource: 'resource',
    Home: 'home',
};
//# sourceMappingURL=rbc-placement.js.map